export enum AwardError {
  INVALID_USER_SESSION = 'invalid-user-session', // 401
  INVALID_PASSENGER_COUNT = 'invalid-passenger-count', // 400
  INVALID_AIRPORT_CODE = 'invalid-airport-code', // 400
  INVALID_DATE = 'invalid-date', // 400
  NO_FLIGHTS_AVAILABLE_FOR_DATES = 'no-flights-available-for-dates', // 404
  INVALID_POINT_OF_SALE = 'invalid-point-of-sale', // 400
  MISSING_REQUIRED_FIELDS = 'missing-required-fields', // 400
  MISSING_REQUIRED_HEADERS = 'missing-required-headers', // 400
  OFFER_ID_REQUIRED = 'offer-id-required', // 400
  OFFER_ID_NOT_FOUND = 'offer-id-not-found', //400
  OUTBOUND_INBOUND_TOO_CLOSE = 'outbound-inbound-too-close', // 400
  INVALID_OND_PAIR = 'invalid-ond-pair', // 403
  DATES_NOT_WITHIN_RANGE = 'dates-not-within-range', // 400
  PASSENGER_FIELD_ERRORS = 'passenger-field-errors', // 400
  MISSING_PASSENGER = 'no-passenger-to-book', //400

  CONFIRM_PNR_FAILED = 'confirm-pnr-failed', // 500
  PAYMENT_FAILED = 'payment-failed', // 500

  POINT_DEDUCTION_FAILED = 'point-deduction-failed', // 500

  FLIGHT_IS_FULL = 'flight-is-full', // 500
  UNKNOWN = 'unknown', // 500
}
